// https://www.bezkoder.com/react-hooks-jwt-auth/ (see Github link there)

// TODO - switch logout function to ours and call where needed
// (currently, logout button doesn't call the function in this file)

// TODO - merge auth.ts and token.ts (I think they are similar)

import axios from "axios";
import { config } from 'src/constants'

const API_URL = config.url.API_URL + 'api/';

// https://stackoverflow.com/questions/60428490/how-to-trigger-person-click-remember-me-or-not
// TODO -- figure out why this isn't working

const getStorage = () => { return localStorage.hasOwnProperty("remember") ? localStorage : sessionStorage }

export const register = (email: string, password: string) => {
    return axios.post(API_URL + "register/", {
        email,
        password,
    });
};

export const change_password = (email: string, password_old: string, password_new: string) => {
    return axios.put(API_URL + "password/", {
        email,
        password_old,
        password_new
    });
};

export const change_email = (email_old: string, email_new: string, password: string) => {
    return axios.put(API_URL + "email/", {
        email_old,
        email_new,
        password
    });
};

export const login = (email: string, password: string, remember: boolean) => {
    return axios
        .post(API_URL + "token/", {
            email,
            password,
        })
        .then((response) => {
            console.log(response);
            if (response.data.access) { // NOTE - this should just be "access", not "accessToken" !!!
                // maybe it's because we are using Django or something??
                console.log(JSON.stringify(response.data));

                // console.log("set user remember status: ")
                // console.log(remember);

                // console.log("SETTING USER DURING LOGIN!");
                // console.log("remember status: ")
                // console.log(response.data);

                // TODO -- maybe call a getStorage() function instead?
                // Note -- cannot define storage globally (outside function) here like we
                // do in auth.ts and token.ts since it gets evaluated prior to submitting the form!
                // (so remember is in default state -- false)

                // getStorage().setItem("user", JSON.stringify(response.data));

                // getStorage isn't working either. I think this is all part of the promise (?) chain for
                // submitting the form. So, "remember" probably hasn't been set yet in local storage. Let's just
                // use the argument instead!
                (remember ? localStorage : sessionStorage).setItem("user", JSON.stringify(response.data));
            }

            return response.data;
        });
};

// export const logout = () => {
//     storage.removeItem("user");
// };

export const getCurrentUser = () => {
    // console.log("get user remember status: ")
    // console.log(remember);

    const userStr = getStorage().getItem("user");
    if (userStr) return JSON.parse(userStr);

    return null;
};